import { normalizeBoard, text } from './board.mjs';

// Only the server-provided caller identity grants privileges. Missing config fails closed.
export const isMaintainer = (request, configuredAccountId) =>
  typeof configuredAccountId === 'string' && configuredAccountId.length > 0 &&
  request.context?.accountId === configuredAccountId;

// A build can be kept private to one account by setting RESTRICT_TO_ACCOUNT_ID in
// that Forge environment (only development). Unset means open, as in production.
export const PRIVATE_BUILD_MESSAGE = 'This is a private test version of Program Roadmap. Use the regular Program Roadmap macro instead.';
export const assertBuildAccess = (request, restrictToAccountId) => {
  if (typeof restrictToAccountId === 'string' && restrictToAccountId.length > 0 &&
    request.context?.accountId !== restrictToAccountId) throw new Error(PRIVATE_BUILD_MESSAGE);
};

export const canDeleteFeedback =(request, entry, configuredAccountId) =>
  isMaintainer(request, configuredAccountId) || Boolean(request.context?.accountId &&
    request.context.accountId === entry?.accountId);

// Who may edit a restricted roadmap besides the app owner.
export const lockOwner = (board) => text(board?.lockedByAccountId, 128)
  ? { id: text(board.lockedByAccountId, 128), name: text(board.lockedBy, 80) }
  : { id: text(board?.createdByAccountId, 128), name: text(board?.createdBy, 80) };

export const prepareSave = (stored, request, configuredAccountId, callerName) => {
  const currentRevision = Math.max(0, Number(stored?.revision) || 0);
  const expectedRevision = Math.max(0, Number(request.payload?.expectedRevision) || 0);
  if (currentRevision !== expectedRevision) {
    throw new Error('This roadmap changed elsewhere. Refresh before making more edits.');
  }
  const accountId = text(request.context?.accountId, 128);
  const creatorAccountId = text(stored?.createdByAccountId, 128);
  // Anyone who can edit may restrict. The person who restricted it and the app owner
  // then keep editing and may lift it. Restrictions made before this was recorded
  // belong to the creator. Identity comes only from the request context.
  const wasLocked = Boolean(stored?.locked);
  const owner = wasLocked ? lockOwner(stored) : { id: '', name: '' };
  const canEdit = !wasLocked || isMaintainer(request, configuredAccountId) || !owner.id || Boolean(accountId && accountId === owner.id);
  if (!canEdit) {
    throw new Error(`This roadmap is restricted. Only ${owner.name || 'the person who restricted it'} or the app owner can edit it.`);
  }
  const board = normalizeBoard(request.payload?.board, currentRevision + 1);
  const wantsLock = Boolean(request.payload?.board?.locked);
  if (wasLocked && wantsLock) Object.assign(board, { locked: true, lockedBy: text(stored?.lockedBy, 80), lockedByAccountId: text(stored?.lockedByAccountId, 128) });
  else if (wantsLock && accountId) Object.assign(board, { locked: true, lockedBy: text(callerName, 80), lockedByAccountId: accountId });
  else Object.assign(board, { locked: false, lockedBy: '', lockedByAccountId: '' });
  board.updatedAt = new Date().toISOString();
  const latest = board.history.at(-1);
  board.updatedBy = latest?.by || text(stored?.updatedBy, 80);
  board.createdByAccountId = creatorAccountId || accountId;
  board.createdBy = text(stored?.createdBy, 80) || (creatorAccountId ? '' : callerName);
  return board;
};
